import { render, staticRenderFns } from "./project-file-explorer.vue?vue&type=template&id=5b1e36d9&"
import script from "./project-file-explorer.vue?vue&type=script&lang=js&"
export * from "./project-file-explorer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports